import React from "react";
import BillingHistoryMobileTransaction from "../../components/DashBoard/Payment/BillingHistoryMobileTransaction";

const BillingHistoryMobileTransactionContainer = () => {
    return <BillingHistoryMobileTransaction />
}

export default BillingHistoryMobileTransactionContainer;